import z from 'zod';
import { entity, customerRef, timeGranularity, anyLoraConfig, locale, kioskConfig, string, uuid, userPolicies, } from '../common';
export var CustomerType;
(function (CustomerType) {
    CustomerType["Default"] = "default";
    CustomerType["BhvkPaid"] = "bhvk_paid";
    CustomerType["BhvkTrial"] = "bhvk_trial";
})(CustomerType || (CustomerType = {}));
export const alarmCenterOptions = z.object({
    enabled: z.boolean(),
    queueName: string.optional(),
});
export const responsePartnerOptions = z.object({
    enabled: z.boolean(),
});
export const mergeWhenSameOptions = z.object({
    name: z.boolean(),
    severity: z.boolean(),
    type: z.boolean(),
});
export const mergeConfig = z.object({
    enabled: z.boolean(),
    onlyMergeWhenSame: mergeWhenSameOptions,
    maxTimeBetweenAlarmsMs: z.number(),
    retriggerAtsAfterMs: z.number(),
});
export const customerPreferences = z.object({
    alarmAgeLimit: timeGranularity.nullish(),
    mergeConfig: mergeConfig.nullish(),
});
export const namedCustomerRef = z.object({
    ...customerRef.shape,
    name: string,
});
export const customer = z.object({
    ...entity.shape,
    name: string,
    parent: customerRef.nullable().default(null),
    parents: customerRef.array(),
    children: customerRef.array(),
    locale,
    timeZone: string.default('Europe/Amsterdam'),
    alarmCenter: alarmCenterOptions.nullish().default(null),
    responsePartner: responsePartnerOptions.nullish().default(null),
    responsePartners: customerRef.array().default([]),
    billingContracts: uuid.array().default([]),
    preferences: customerPreferences.nullish(),
    loraConfig: anyLoraConfig.array().nullish(),
    kioskConfig: kioskConfig.nullish(),
    type: z.nativeEnum(CustomerType).optional(),
    userPolicies: userPolicies.optional(),
});
